module.exports = __webpack_public_path__ + "static/media/majorE5.95bd8cd.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorE5.wav
// module id = mQ56
// module chunks = 0